<h2 mat-dialog-title>Reparar ficheros</h2>

<mat-dialog-content>

  <p class="repair-hint">
    Comprueba y corrige ficheros cuya ruta en base de datos no coincide con su ubicación real
    en el almacenamiento (por ejemplo, tras mover carpetas antes de que se corrigiera el bug).
    Primero pulsa <strong>Analizar</strong> para ver el diagnóstico sin cambiar nada.
  </p>

  <div class="repair-scope-toggle">
    <button mat-stroked-button [color]="scope === 'user' ? 'primary' : ''" (click)="setScope('user')"
      [disabled]="loading">
      Un usuario
    </button>
    <button mat-stroked-button [color]="scope === 'all' ? 'primary' : ''" (click)="setScope('all')"
      [disabled]="loading">
      Todos los usuarios
    </button>
  </div>

  <app-input *ngIf="scope === 'user'" inputType="text" placeholder="UID del usuario" style="width:100%"
    [(ngModel)]="userUid" [disabled]="loading"></app-input>

  <p class="repair-hint" *ngIf="scope === 'all'">
    ⚠️ Recorre todos los usuarios con ficheros. Puede tardar bastante si hay muchos clientes;
    lanza primero en modo Analizar antes de aplicar.
  </p>

  <div *ngIf="error" class="repair-error">{{ error }}</div>

  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="32"></mat-spinner>
  </div>

  <!-- Resultado: un usuario -->
  <div *ngIf="scope === 'user' && result && !loading" class="repair-result">
    <p><strong>Modo:</strong> {{ result.mode }}</p>
    <p>Total ficheros: {{ result.totalFiles }}</p>
    <p>✅ Correctos/reparados: {{ result.repairedCount }}</p>
    <p>⚠️ Ambiguos (requieren revisión manual): {{ result.ambiguousCount }}</p>
    <p>❌ No encontrados: {{ result.missingCount }}</p>

    <div *ngIf="result.repaired?.length > 0">
      <h4>Reparados</h4>
      <ul>
        <li *ngFor="let r of result.repaired">
          {{ r.note }} ({{ r.path }}) — {{ r.sourceKey }} → {{ r.expectedKey }}
        </li>
      </ul>
    </div>

    <div *ngIf="result.ambiguous?.length > 0">
      <h4>Ambiguos</h4>
      <ul>
        <li *ngFor="let a of result.ambiguous">
          {{ a.note }} ({{ a.path }}) — {{ a.candidates?.length }} candidatos posibles
        </li>
      </ul>
    </div>

    <div *ngIf="result.missing?.length > 0">
      <h4>No encontrados</h4>
      <ul>
        <li *ngFor="let m of result.missing">
          {{ m.note }} ({{ m.path }})
        </li>
      </ul>
    </div>
  </div>

  <!-- Resultado: todos los usuarios -->
  <div *ngIf="scope === 'all' && resultAll && !loading" class="repair-result">
    <p><strong>Modo:</strong> {{ resultAll.mode }}</p>
    <p>Usuarios comprobados: {{ resultAll.usersChecked }}</p>
    <p>⚠️ Usuarios con inconsistencias: {{ resultAll.usersWithIssuesCount }}</p>

    <div *ngIf="resultAll.usersWithIssues?.length > 0">
      <h4>Usuarios afectados</h4>
      <ul>
        <li *ngFor="let u of resultAll.usersWithIssues">
          <strong>{{ u.username }}</strong> ({{ u.userUid }}) —
          reparados: {{ u.repairedCount }}, ambiguos: {{ u.ambiguousCount }}, no encontrados: {{ u.missingCount }}
        </li>
      </ul>
      <p class="repair-hint">
        Para ver el detalle o aplicar la corrección de un usuario concreto, cambia a "Un usuario"
        y pega su UID.
      </p>
    </div>

    <div *ngIf="!resultAll.usersWithIssues?.length">
      <p>No se han encontrado inconsistencias en ningún usuario. 🎉</p>
    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cerrar</button>
  <button mat-button color="primary" (click)="analyze()" [disabled]="loading">
    Analizar
  </button>
  <button mat-raised-button color="warn" (click)="apply()"
    [disabled]="loading || (scope === 'user' ? !result : !resultAll)">
    Aplicar reparación
  </button>
</mat-dialog-actions>
